import React from 'react';
import { Link } from 'react-router-dom';
import { Header } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { YesNoDialog } from 'Components/dialogs/YesNoDialog';
import { resetDirty } from 'State/dirtyTracking/actions';

class AppHeaderLogoContainer extends React.Component {
  state = {
    showYesNoConfirm: false,
  };

  render() {
    return (
      <div id="app-header-logo">
        <Link to="/home">
          <Header
            as="h1"
            onClick={e => {
              if (this.props.getPageLevelDirty()) {
                e.preventDefault();
                this.setState({ showYesNoConfirm: true });
              }
            }}
          >
            Meals Plus
          </Header>
        </Link>
        <YesNoDialog
          isSavePrompt={true}
          showDialog={this.state.showYesNoConfirm}
          yesCallback={() => {
            this.props.resetDirty();
            this.setState({ showYesNoConfirm: false });
            this.props.history.push('/home');
          }}
          noCallback={() => {
            this.setState({ showYesNoConfirm: false });
          }}
        />
      </div>
    );
  }
}

export const AppHeaderLogo = withRouter(
  connect(null, { resetDirty })(AppHeaderLogoContainer)
);



// WEBPACK FOOTER //
// ./src/components/app/header/Logo.js